import * as React from 'react';
import { compose, setDisplayName, withProps, withState } from 'recompose';
import { translate } from 'react-i18next';
import { TranslateProps } from 'util/i18n';
import { ReportSettings, ReportSettingsChangeHandler } from 'logic/reports/ReportSettings';
import { Fade } from 'ui/transitions';
import { RecurrenceYearlyDayNum } from './RecurrenceYearlyDayNum';
import { RecurrenceYearlyDay } from './RecurrenceYearlyDay';

export type OwnProps = {
    reportSettings: Readonly<ReportSettings>;
    onChange: ReportSettingsChangeHandler;
};

const RawRecurrenceYearly = (props: OwnProps & RecomposeProps & TranslateProps) =>
    <Fade
        id="edit-schedule-recurrence-panel-yearly"
        className="edit-schedule-recurrence-panel"
        visible={ props.enabled }
        duration={ 400 }
    >
        <div>
            <RecurrenceYearlyDayNum { ...props }/>
            <RecurrenceYearlyDay { ...props }/>
        </div>
    </Fade>
;

type RecomposeProps = {
    enabled: boolean;
    useDayNum: boolean;
    onChangeUseDayNum: (b: boolean) => void;
};

export const RecurrenceYearly = compose<OwnProps & RecomposeProps & TranslateProps, OwnProps>(
    setDisplayName('RecurrenceYearly'),
    translate(),
    withProps(({ reportSettings }: OwnProps) => ({
        enabled: reportSettings.scheduleType === 'Yearly',
    })),
    withState('useDayNum', 'onChangeUseDayNum', ({ reportSettings }: OwnProps) => reportSettings.useScheduleYearlyDayNum),
)(RawRecurrenceYearly);



// WEBPACK FOOTER //
// ./src/ui/pages/designer/sections/schedule/runOnSchedule/recurrence/RecurrenceYearly.tsx